import AssignEmployeesToPropertyModal from "./AssignEmployeesToPropertyModalContainer";

export default AssignEmployeesToPropertyModal;
